import React from 'react';
import { motion } from 'framer-motion';
import BuyButtons from './BuyButtons';

const PurchaseSection = () => (
  <section id="buy" className="py-24 bg-brand-light relative">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <span className="text-brand-accent font-semibold tracking-widest uppercase text-xs">Choose Your Format</span>
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-dark mt-3 mb-5">
          Begin Your Journey Today
        </h2>
        <p className="text-lg text-slate-600 mb-12 max-w-2xl mx-auto">
          The connection you deserve is one book away. Available in digital, paperback, and hardcover — wherever you are in the world.
        </p>
        <BuyButtons />
      </motion.div>
    </div>
  </section>
);

export default PurchaseSection;